import Vue from 'vue'

import Vuex from 'vuex'
Vue.use(Vuex)

// eslint-disable-next-line no-undef
const merge = require('deepmerge')

import quote from './quote.js';
import app from './app.js';
import msg from './msg.js';
import menu from './menu.js';
import window from './window.js';
import badge from './badge.js';
import modules from './modules';

const mainStore = {
  strict: process.env.NODE_ENV !== 'production',
  modules
}

const finalStore = merge.all([mainStore, quote, app, msg, menu, window, badge])
// console.log(finalStore)

export default new Vuex.Store(finalStore)
